import React from 'react';
import './index.css';
import heardIcon from '../../assets/heardIcon.svg';

const heardTitle = (props: any) => {
  return (
    <div className='heardTitle scrollIcon' data-start={props?.position?.start?.line ?? ''} data-end={props?.position?.end?.line ?? ''} data-page={props?.page ?? 0}>
      <img className='heardIcon' src={heardIcon} alt="" />
      <span className={props.className} style={{ fontSize: '24px' }}>{props.children}</span>
    </div>
  );
};

export default heardTitle;
